import React, { useState, useEffect, useRef } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import "./style.css";

import Question from "../../components/Question";
import { TestSteps } from "../../routes/Home";

import Autobot from "../../utils/autobot";

const PageTest = ({ questions, patterns, handleCurrentStep, handleClearGoddessList }) => {
  const [currentThemeIndex, setCurrentThemeIndex] = useState(0);
  const [answerList, setAnswerList] = useState([]);
  const questionRef = useRef(null);

  const handleChangeTheme = (next, answers) => {
    if (next) {
      setAnswerList((prevAnswers) => {
        const updatedAnswers = [...prevAnswers];
        const currentThemeAnswers = {
          ...(updatedAnswers[currentThemeIndex] || {}),
          ...answers,
        };

        updatedAnswers[currentThemeIndex] = currentThemeAnswers;
        return updatedAnswers;
      });
    }
    setCurrentThemeIndex((prevIndex) => (next ? prevIndex + 1 : prevIndex - 1));

    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const handleEndTest = () => {
      let goddessFinal = [];
      patterns.forEach((goddess) => {
        let goddessSum = 0;
        goddess.answerPattern.forEach((answerPattern, answerPatternIndex) => {
          let sumValue = answerList[answerPatternIndex][answerPattern - 1];
          goddessSum += sumValue > 0 ? sumValue : -1;
        });

        goddessFinal.push({
          goddess: goddess.name,
          score: goddessSum,
        });
      });

      let jsonFinal = goddessFinal.reduce((acc, { goddess, score }) => {
        const goddessClean = goddess
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();

        acc[goddessClean] = score;
        return acc;
      }, {});

      handleCurrentStep(TestSteps.Email);
      jsonFinal = calculatePercentages(jsonFinal);
      console.log("jsonFinal ", jsonFinal);
      handleClearGoddessList(jsonFinal);
    };
    if (questions.length > 0 && currentThemeIndex > questions.length - 1) {
      handleEndTest();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentThemeIndex, answerList, questions.length, patterns]);

  function calculatePercentages(jsonData) {
    const total = Object.values(jsonData).reduce((acc, curr) => acc + curr, 0);
    const percentages = {};
    let remainingPercentage = 100;

    for (const key in jsonData) {
      if (jsonData.hasOwnProperty(key)) {
        percentages[key] = Math.round((jsonData[key] / total) * 100);
        remainingPercentage -= percentages[key];
      }
    }

    // Distribui a diferença de arredondamento para a última chave
    const keys = Object.keys(jsonData);
    percentages[keys[keys.length - 1]] += remainingPercentage;

    return percentages;
  }

  function capitalizeFirstLetters(inputString) {
    return inputString
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return (
    <section className="main-wrapper">
      {currentThemeIndex < questions.length && (
        <TransitionGroup ref={questionRef}>
          <CSSTransition
            key={currentThemeIndex}
            timeout={500}
            classNames="question-transition"
            ref={questionRef}
          >
            <div className="main-container" ref={questionRef}>
              <div className="question-container" ref={questionRef}>
                <Question
                  themeIndex={currentThemeIndex}
                  theme={capitalizeFirstLetters(questions[currentThemeIndex]?.theme)}
                  questions={questions[currentThemeIndex].questions}
                  handleChangeTheme={handleChangeTheme}
                  answerList={answerList[currentThemeIndex]}
                  themeTotal={questions.length}
                />
              </div>
            </div>
          </CSSTransition>
        </TransitionGroup>
      )}
      <Autobot></Autobot>
    </section>
  );
};

export default PageTest;
